/**
 * PATH: apps/qa/src/lib/api/evidence.ts
 * PURPOSE: Evidence API for photos, documents, notes, signatures
 */

import { api, normaliseList } from './helpers'

export interface EvidenceItem {
  id: string; inspection: string | null; floor: string | null; area: string | null
  item_instance: string | null; hold_point: string | null
  type: 'photo' | 'video' | 'document' | 'note' | 'signature'
  asset_id: string | null; asset_url: string | null; display_url?: string | null; note_text: string | null
  description: string; folder: string
  captured_by: string | null; captured_by_name: string | null; captured_at: string
  device_metadata: Record<string, unknown> | null
  is_addendum: boolean; addendum_reason: string; created_at: string
}

export const evidenceApi = {
  getEvidence: async (params?: { inspection_id?: string; floor_id?: string; area_id?: string; item_instance_id?: string; type?: string; folder?: string; page?: number; page_size?: number }): Promise<{ results: EvidenceItem[]; count: number }> => {
    const response = await api().get('/qa/evidence/', { params })
    return normaliseList(response.data)
  },
  getEvidenceItem: async (id: string): Promise<EvidenceItem> => {
    const response = await api().get(`/qa/evidence/${id}/`)
    return response.data
  },
  createEvidence: async (data: { inspection?: string | null; floor?: string | null; area?: string | null; item_instance?: string | null; hold_point?: string | null; type: EvidenceItem['type']; asset_id?: string | null; note_text?: string | null; description?: string; folder?: string; device_metadata?: Record<string, unknown>; addendum_reason?: string }): Promise<EvidenceItem> => {
    const response = await api().post('/qa/evidence/', data)
    return response.data
  },
  deleteEvidence: async (id: string): Promise<void> => { await api().delete(`/qa/evidence/${id}/`) },
}
